<template lang="pug">
.v-informer.informer(v-if="info" :class="[direction ? 'informer--' + direction : '', open ? 'open' : '']")
	.informer__slot-btn(v-if="$slots['btn']" @mouseenter="isTablet ? null : open = true" @mouseleave="isTablet ? null : open = false" @click="open = !open")
		slot(name="btn")
	button.informer__btn(v-else="" type="button" @mouseenter="isTablet ? null : open = true" @mouseleave="isTablet ? null : open = false" @click="open = !open")
		v-svg-icon.informer__btn-icon(icon="informer")
	v-panel(v-if="isTablet" :open-state="open")
		template(#content)
			.informer__panel-content(v-html="info.content")
	transition(v-else="" name="fade")
		.informer__panel.scrollbar(v-if="open" v-html="info.content" :ref="setBody")
</template>

<script>

import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	props: {
		info: {
			type: Object,
			default: null
		}
	},

	mixins: [
		isMobMixin
	],

	watch: {
		body(state) {
			if (state) {
				this.checkDirection();
			}
		}
	},

	created() {
		this.checkDirection();
		window.addEventListener('resize', this.resizeHandler);
		document.addEventListener('click', this.handlerClickOutside);
	},

	unmounted() {
		window.removeEventListener('resize', this.resizeHandler);
		document.removeEventListener('click', this.handlerClickOutside);
	},

	data() {
		return {
			open: false,
			direction: null,
			body: null
		}
	},

	methods: {
		handlerClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		resizeHandler() {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(this.checkDirection, 400);
		},

		checkDirection() {
			if (this.body) {
				this.direction = window.innerWidth < this.body.getBoundingClientRect().left + this.$refs.clientWidth ? 'left' : this.direction;
			}
		},

		setBody(el) {
			this.body = el;
		}
	}
}

</script>